var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("csp-form-select-searchable", {
    staticStyle: { "min-width": "500px" },
    attrs: {
      label: "Benutzerwechsel",
      "options-loader": _vm.loadUserOptions,
      value: _vm.user,
    },
    on: { change: _vm.selectUser },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }